(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-gallery-all-images"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPgai(section){
    if(!section || section.__pgaiBound) return;
    section.__pgaiBound = true;

    /* Lightbox */
    const lightbox = section.querySelector('.pgai-lightbox');
    const stage    = section.querySelector('.pgai-lightbox__stage');
    const tpl      = section.querySelector('template[id^="pgai-templates"]');
    const slides   = tpl ? Array.from(tpl.content.querySelectorAll('.pgai-slide')) : [];

    let lbIndex = 0, touchStartX = null;

    function lbRender(){
      if(!stage || !slides.length) return;
      stage.innerHTML = '';
      stage.appendChild(slides[lbIndex].cloneNode(true));
    }
    function lbOpen(i){
      if(!lightbox || !slides.length) return;
      lbIndex = i || 0;
      lbRender();
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('pgai-lock');
    }
    function lbClose(){
      if(!lightbox) return;
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('pgai-lock');
      if(stage) stage.innerHTML = '';
    }
    function lbPrev(){ lbIndex = (lbIndex - 1 + slides.length) % slides.length; lbRender(); }
    function lbNext(){ lbIndex = (lbIndex + 1) % slides.length; lbRender(); }

    section.addEventListener('click', (e)=>{
      const thumb = e.target.closest('.pgai-thumb');
      if(thumb && section.contains(thumb)){
        const i = parseInt(thumb.dataset.index, 10) || 0;
        lbOpen(i);
        return;
      }
      if(e.target.closest('[data-pgai-close]')) { lbClose(); return; }
      if(e.target.closest('[data-pgai-prev]'))  { lbPrev();  return; }
      if(e.target.closest('[data-pgai-next]'))  { lbNext();  return; }
    });

    section.addEventListener('keydown', (e)=>{
      if(!lightbox || lightbox.hidden) return;
      if(e.key === 'Escape') lbClose();
      else if(e.key === 'ArrowLeft') lbPrev();
      else if(e.key === 'ArrowRight') lbNext();
    });

    if(stage){
      stage.addEventListener('touchstart', (e)=>{ touchStartX = e.changedTouches[0].screenX; }, {passive:true});
      stage.addEventListener('touchend', (e)=>{
        if(touchStartX == null) return;
        const dx = e.changedTouches[0].screenX - touchStartX;
        if(Math.abs(dx) > 50) (dx > 0 ? lbPrev() : lbNext());
        touchStartX = null;
      }, {passive:true});
    }

    /* Load More */
    const grid = section.querySelector('.pgai-grid');
    if(!grid) return;

    const items = Array.from(grid.querySelectorAll('.pgai-item'));
    const btn   = section.querySelector('[data-pgai-load-more]');
    const enableLoadMore = grid.getAttribute('data-enable-loadmore') === 'true';
    const rowsInitial    = parseInt(grid.getAttribute('data-rows-initial') || '2', 10);
    const rowsIncrement  = parseInt(grid.getAttribute('data-rows-increment') || '2', 10);

    let extraRows = 0;

    function getColumnCount(){
      const gcs = getComputedStyle(grid);
      const template = gcs.getPropertyValue('grid-template-columns');
      const cols = (template && template.trim()) ? template.trim().split(/\s+/).length : 1;
      return Math.max(1, cols);
    }

    function applyVisibility(){
      const cols = getColumnCount();
      const rowsVisible = rowsInitial + extraRows;
      const limit = cols * rowsVisible;

      items.forEach((el, i)=>{ el.hidden = i >= limit; });

      const anyHidden = items.some((el)=> el.hidden);
      if(btn && enableLoadMore){
        btn.hidden = !anyHidden;
      }
    }

    function onResizeThrottled(){
      if(onResizeThrottled._raf) return;
      onResizeThrottled._raf = requestAnimationFrame(()=>{
        onResizeThrottled._raf = null;
        applyVisibility();
      });
    }

    applyVisibility();

    if(btn && enableLoadMore){
      btn.addEventListener('click', ()=>{
        extraRows += rowsIncrement;
        applyVisibility();
      });
    }

    window.addEventListener('resize', onResizeThrottled);
    window.addEventListener('orientationchange', onResizeThrottled);
  }

  function initAll(){
    document.querySelectorAll('.pgai').forEach(initPgai);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load',   (e)=>{ const s = e.target.querySelector('.pgai'); if(s) initPgai(s); });
  document.addEventListener('shopify:section:select', (e)=>{ const s = e.target.querySelector('.pgai'); if(s) initPgai(s); });
})();

  } catch(e) { console.error(e); }
})();
})();
